import * as React from "react";
import { makeStyles } from "@mui/styles";
import Text from "components/common/Text";
import Box from "components/common/Box";
import Button from "components/common/Button";
import Dialog from "components/common/DialogXS";
import TextField from "@mui/material/TextField";
import OTPSendModal from "./OTPSendModal";
import Alert from "components/common/Alert";

const ForgotPasswordForm = ({
  email_mobile,
  EmailMobileChecker,
  onSubmit,
  formError,
  isError,
  isOpenDialog,
  onDialogClose,
}) => {
  const classes = useStyles();
  const iconData = [];
  iconData.src = "Group 20449/Group 20390.svg";
  return (
    <Box className={classes.login_container_fp}>
      <Text
        sx={{
          fontSize: "20px",
          fontWeight: "bold",
        }}
        className={classes.welcome_text}
      >
        Forgot Password
      </Text>
      <TextField
        fullWidth
        size="small"
        id="outlined-basic"
        label="Enter email id / contact number"
        variant="outlined"
        style={{ marginTop: "20px" }}
        value={email_mobile}
        onChange={(e) => EmailMobileChecker(e.target.value)}
        onInput={(e) => {
          e.target.value = e.target.value.trimStart();
        }}
        helperText={formError.email_mobile}
        error={formError.email_mobile}
        InputLabelProps={{ style: { fontSize: 16 } }}
      />
      <Box mt={3}>
        <Button
          sx={{ fontSize: "16px" }}
          className={classes.LoginButton}
          type="submit"
          onClick={onSubmit}
        >
          SUBMIT
        </Button>
      </Box>
      {isError !== "" ? (
        <Box>
          <Alert severity="error">{isError}</Alert>
        </Box>
      ) : (
        ""
      )}
      <Box mt={1.8}>
        <Text
          sx={{
            fontSize: "14px",
            fontWeight: "regular",
          }}
        >
          <Dialog
            open={isOpenDialog}
            onClose={onDialogClose}
            title="OTP Sent"
            disableCloseIcon
            icon={iconData}
            children={<OTPSendModal formError={formError} />}
          />
        </Text>
      </Box>
    </Box>
  );
};
const useStyles = makeStyles((theme) => ({
  login_container_fp: {
    position: "relative",
    top: "80%",
    marginLeft: "8rem",
    ["@media (max-width:768px)"]: {
      marginLeft: "0px",
    },
  },
  welcome_text: {
    // fontFamily: "Nunito Sans",
  },

  LoginButton: {
    opacity: "100%",
    backgroundColor: "#19aa69",
    color: "white",
    width: "100% !important",
    border: "none",
    height: "50px",
    marginTop: "20px",
  },
}));
export default ForgotPasswordForm;
